<template>
  <div >

          <div class="md-layout" v-if="loading">
                 
                  <div class="md-layout-item md-size-100">
                        <md-progress-spinner  :md-diameter="30" md-mode="indeterminate"></md-progress-spinner> {{msg_status}} ..
                  </div>
         </div>
         <table class="striped responsive-table" style="width: 100%;">
             <thead>
             	<tr>
                     
                           <th >ID</th>  
                            <th>Nome</th>  
                            <th>Cargo</th> 
                            <th>Telefone</th>  
                            <th>E-mail</th>  
                            <th>Setor</th>  
                            <th>Função</th>  
                            <th>Tipo Contato</th>  
                       
                     </tr>
              </thead>
             <tbody>
                 <tr v-for="(item, index) in items" :key="index" >
                      <td >{{item.id}} </td>
                      <td>{{item.nome}} </td>
                      <td>{{item.cargo}} </td>
                      <td>{{item.telefone}} </td>
                      <td>{{item.email}} </td>
                      <td>{{item.setor}} </td>
                      <td>{{item.funcao}} </td>
                      <td>{{item.tipo_contato}} </td>
                  </tr>
             </tbody>
             <tfoot v-if="items.length <= 0">
                        <tr >
                                  <td colspan="8"><i>Não há dados</i></td>
                        </tr>

             </tfoot>
        </table>
  </div > 
</template> 

<script>

import service from "../../../services/ContatosService";


    export default {
        props: ['tabela', 'id_pai'],
        data: function() {
            return {
                
              items: [],

              ids_excluir: [],

              action: "list",
              id: "",
              table: null,
              filtro_titulo: "",
              filtro_status: "",

              show_new_button: true,

              loading: true,
              msg_status: "Carregando..",

              button_new_text: "" //<i class=\"fa fa-file\" ></i> NOVA POST"
            }
        },
        methods: {
            
                     loadData(){


                                        let self = this;
                                        this.loading = true;

                                        if ( this.tabela == null || this.id_pai == null ){
                                            return;
                                        }


                                        var url =  "contatos_gridcad"; // 
                                        this.disableButton = true;

                                        var data = { }

                                        service.getList( this.tabela, this.id_pai ).then(function (response){


                                                        self.items = response.data.data;
                                                        self.disableButton = false;
                                                        self.loading = false;
                                        }).catch(function(error){
                                            console.log( JSON.parse(  JSON.stringify(error)));
                                        });


                     }
        },
        mounted() {

                     this.loadData();
                
  
        }
    }
    </script>                